import { FormList, FormUnit } from "@suse-o11y/signal/form";

import type { TimeRange } from "../../app/state/view/timeline/TimeRange";
import type { DashboardVariable } from "../../common/dashboard-spec";

export type VariableState = FormUnit<DashboardVariable, string>;

function initVariableState(variable: DashboardVariable): VariableState {
	return FormUnit<DashboardVariable, string>(variable, {
		isInputEqual: (left, right) => left.isEqual(right),
	});
}

export type VariablesState = FormList<VariableState>;

export function initVariablesState(variables: ReadonlyArray<DashboardVariable>): VariablesState {
	return FormList(initVariableState, {
		initial: variables,
	});
}

export interface DrawerState {
	id?: string;
	variables: VariablesState;
	timeRange: TimeRange;
	onSave: (variables: ReadonlyArray<DashboardVariable>) => void;
}
